<template>
  <div>
    <div class="demo-padding">
      <div class="main">
        <span class="title" @click="onSwitch">
          <img
            class="question"
            src="https://s3.meituan.net/static-prod01/com.sankuai.fspfepayresource.ibalance-files/question-icon.png"
            alt=""
          />
          <span class="sub-title">{{ questionItem.title }}</span>
          <img
            src="https://p0.meituan.net/wxapp/3753cd32654788440bce014181879cf5342.png"
            alt=""
            class="access-right"
            :class="getRightAccess"
          />
        </span>
        <div v-for="(item, index) in questionItem.content" :key="index">
          <div v-if="showSelect" class="content">{{ item }}</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import Vue from 'vue';

export default Vue.extend({
  name: 'QuestionList',
  components: {
    // vv
  },
  props: {
    questionItem: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      showSelect: this.questionItem.show,
    };
  },
  computed: {
    getRightAccess(): string {
      if (this.showSelect) {
        return 'access-top';
      }
      return 'access-bottom';
    },
  },
  created() {},
  methods: {
    onSwitch() {
      this.showSelect = !this.showSelect;
    },
  },
});
</script>

<style lang="less" scoped>
.main {
  // padding-bottom: 0.28rem;
  .title {
    display: flex;
    align-items: center;
    position: relative;
    padding-top: 0.28rem;
    padding-bottom: 0.18rem;
    padding-left: 0.02rem;
    .question {
      width: 0.36rem;
      height: 0.36rem;
    }
    .sub-title {
      padding-left: 0.06rem;
      margin-left: 0.2rem;
      opacity: 0.9;
      font-family: PingFangSC-Regular, sans-serif;
      font-size: 0.28rem;
      color: #000000;
      line-height: 0.28rem;
      font-weight: 400;
    }
    .access-right {
      position: absolute;
      right: 0;
      width: 0.24rem;
      height: 0.24rem;
    }
    .access-top {
      transform: rotate(-90deg);
      transition: 0.2s ease-in-out;
    }
    .access-bottom {
      transform: rotate(90deg);
      transition: 0.2s ease-in-out;
    }
  }
  .content {
    padding-left: 0.62rem;
    opacity: 0.4;
    font-family: PingFangSC-Regular, sans-serif;
    font-size: 0.26rem;
    color: #000000;
    text-align: justify;
    line-height: 0.38rem;
    font-weight: 400;
    padding-bottom: 0.28rem;
  }
}
</style>
